<template>
    <div class="external-model__edit">
        <external-model-form
            :external-model="$props.externalModel"
            @submit="updateExternalModel"
        >
            <template #actions>
                <div class="actions">
                    <delete-model-btn
                        :modal-title="$t('model.external-model.edit-external-model.deleteExternalModelTitle')"
                        @delete="deleteModel"
                        :is-deleting="$props.isDeleting || $props.isEditing"
                    />
                    <div>
                        <or-button
                            class="cancel-button"
                            color="primary"
                            type="secondary"
                            buttonType="button"
                            :loading="isEditing"
                            @click="cancelEditing"
                        >
                          {{ $t('generic.cancel') }}
                        </or-button>
                        <or-button
                            color="primary"
                            buttonType="submit"
                            :loading="isEditing"
                        >
                          {{ $t('generic.update') }}
                        </or-button>
                    </div>
                </div>
            </template>
        </external-model-form>
    </div>
</template>

<script>
import ExternalModelForm from '@/components/common/modals/create_external/external-model-form'
import DeleteModelBtn from '../common/delete-model-button'

export default {
  components: {
    ExternalModelForm,
    DeleteModelBtn
  },

  props: {
    externalModel: Object,
    isEditing: Boolean,
    isDeleting: Boolean
  },

  methods: {
    updateExternalModel (externalModel) {
      this.$emit('edit', externalModel)
    },

    deleteModel () {
      this.$emit('delete')
    },

    cancelEditing () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
    .external-model__edit {
        overflow: scroll;
    }

    .actions {
        display: flex;
        justify-content: space-between;
        .cancel-button {
            margin-right: $sp-3;
        }
    }
</style>
